<template>
	<div>
		<buttonlist @help="help" @add="add" @del="batchdel" @reflash="reflash" @exps="exps" @save="save"
		ref="SetBtn"
		></buttonlist>
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[3138]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="description" :label="$t('getapi[8091]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="dutyman" :label="$t('getapi[3139]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="tel1" :label="$t('getapi[3140]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="tel2" :label="$t('getapi[3141]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="fax" :label="$t('getapi[2612]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="intel" :label="$t('getapi[3142]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="cargoposition_code" :label="$t('getapi[188]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remarks" :label="$t('getapi[143]')" width="100"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="100">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
					<el-popconfirm
						:confirmButtonText="$t('getapi[1146]')"
						:cancelButtonText="$t('getapi[2054]')"
						icon="el-icon-info"
						iconColor="red"
						:title="$t('getapi[6049]')"
						@onConfirm="del(scope.row)"
					>
						<el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog v-dialogDrag :title="$t('getapi[1063]')" :visible.sync="isVisible" width="30%">
			<!--<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px" label-position="left" size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3138]')"><el-input v-model="dataDetail.name"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[8091]')"><el-input v-model="dataDetail.description"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3139]')"><el-input v-model="dataDetail.dutyman"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3140]')"><el-input v-model="dataDetail.tel1"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3141]')"><el-input v-model="dataDetail.tel2"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[2612]')"><el-input v-model="dataDetail.fax"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[3142]')"><el-input v-model="dataDetail.intel"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[143]')"><el-input v-model="dataDetail.remarks"></el-input></el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>-->
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[3138]')}}</td>
					<td><el-input v-model="dataDetail.name" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[8091]')}}</td>
					<td><el-input v-model="dataDetail.description" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3139]')}}</td>
					<td><el-input v-model="dataDetail.dutyman" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[3140]')}}</td>
					<td><el-input v-model="dataDetail.tel1" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3141]')}}</td>
					<td><el-input v-model="dataDetail.tel2" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[2612]')}}</td>
					<td><el-input v-model="dataDetail.fax" type="text" size="mini"></el-input></td>
				</tr>
				<tr>
					<td>{{$t('getapi[3142]')}}</td>
					<td><el-input v-model="dataDetail.intel" type="text" size="mini"></el-input></td>
					<td>{{ $t('getapi[188]') }}</td>
					<td>
						<routejump :urlNo="9">
							<el-input v-model="dataDetail.cargoposition_code" type="text" size="mini">
								<i class="el-icon-edit el-input__icon" slot="suffix" @click="selectCargo()"></i>
							</el-input>
						</routejump>
					</td>
				</tr>
				<tr>
					<td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataDetail.remarks" type="text" size="mini"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="small" type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>

		<!-- 默认货位 -->
		<selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage="true"
				  :postUrl="'/Eng/Parts/GetPartDefCargoPPopupList'" @callback="getcargo" ref="cargo"></selector>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'department',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			userData: [], // 用户信息
			user: '', // 当前用户
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 50, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			dataDetail: {},
			selectIDData: [],
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.getView();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1063]"),this.$t("getapi[12]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			//只读权
			if (that.$limits.ReadOnlyRights('plv2', 2, 1)) {
				that.$refs.SetBtn.SetButtonEnable('refresh,export');
			}
			//操作权
			if (that.$limits.authority('plv2', 2, 1) == 2) {
				if (that.$limits.authority('plv3', 2, 1) == 0) {//查询级
					that.btn.edit = false;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('refresh,export');
				}
				if (that.$limits.authority('plv3', 2, 1) == 1) {//编辑级
					that.btn.edit = true;
					that.btn.del = false;
					that.$refs.SetBtn.SetButtonEnable('create,refresh,export');
				}
				if (that.$limits.authority('plv3', 2, 1) == 2) {//删除级
					that.btn.edit = true;
					that.btn.del = true;
					that.$refs.SetBtn.SetButtonEnable('create,del,refresh,export');
				}
			}
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let data = {};
			that.$http.urlpost('/Sys/Currency/GetDepartmentList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent.Table;
					that.loading = false;
				}
				that.authority();
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
			that.authority();
		},
		edit(row) {
			let that = this;
			that.isVisible = true;
			let parm = {
				Id: row.num
			};
			that.$http.urlpost('/Sys/Currency/GetDepartmentInfo', parm, function(res) {
				if (res.Success == 1) {
					that.dataDetail = res.DataContent;
				}
			});
		},
		// 导出
		exps() {
			let that = this;
			let parm = {
                LangType:that.$processdata.getLang(),
                fromname: that.$t('getapi[3143]')
			};
			that.$http.urlpost('/Sys/Currency/DepartmentExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
		save() {
			let that = this;
			let arr = [];
			arr = [...arr, that.dataDetail];
			let parm = arr;
			that.$http.urlpost('/Sys/Currency/SaveDepartment', parm, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.isVisible = false;
					that.getView();
				}
			});
		},
		add() {
			let that = this;
			let datetime = (
				new Date().getFullYear() +
				'-' +
				(new Date().getMonth() + 1) +
				'-' +
				new Date().getDate() +
				' ' +
				new Date().getHours() +
				':' +
				new Date().getMinutes() +
				':' +
				new Date().getSeconds()
			).toString();
			that.isVisible = true;
			that.dataDetail = {
				num: 0,
				name: '',
				description: '',
				dutyman: '',
				tel1: '',
				tel2: '',
				fax: '',
				intel: '',
                cargoposition_code:'',
				remarks: '',
				createruser: that.user,
				createtime: datetime,
				updateuser: '',
				updatetime: '',
				isdelete: false,
				issealed: false
			};
		},
		del(row) {
			let that = this;
			let parm = {
				ids: row.num,
				exclusively_id: 0
			};
			that.$http.urlpost('/Sys/Currency/DelDepartmentByID', parm, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
			});
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectIDData = [];
			for (let i = 0; i < val.length; i++) {
				that.selectIDData.push(val[i].num);
			}
		},
		batchdel() {
			let that = this;
			if(that.selectIDData.length == 0){
                that.$message.warning(this.$t('getapi[1158]'));
                return false
            }
			that.$confirm(this.$t('getapi[6049]'), this.$t('getapi[194]'), {
				confirmButtonText: this.$t('getapi[1146]'),
				cancelButtonText: this.$t('getapi[2054]'),
				type: 'warning'
			})
				.then(() => {
					let ids = '';
					for (let i = 0; i < that.selectIDData.length; i++) {
						ids = ids + that.selectIDData[i] + ',';
					}
					ids = ids.substr(0, ids.length - 1);
					let parm = {
						ids: ids,
						exclusively_id: 0
					};
					that.$http.urlpost('/Sys/Currency/DelDepartmentByID', parm, function(res) {
						if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
							that.getView();
						}
					});
				})
				.catch(() => {});
		},
        selectCargo() {
            let that = this;
            that.$refs.cargo.clearInput(true);
        },
        getcargo(data) {
            let that = this;
            that.dataDetail.cargoposition_code = data.cargoposition_code;
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
